// <Invite> — the 邀请朋友 overlay (#invite): room code + share link + (in the lobby) the "bring an AI
// agent" one-liner. PURE function of `app`; emits the SAME class names + data-action attrs as the
// classic showInvite() string (copy-invite / copy-agent-invite / close-invite) so document-level click
// delegation + the smoke grep contract stay green. See PREACT-MIGRATION.md.
//
// roomUrl()/inviteText() stay global (the copy-invite action reads them); the component only
// needs the URL string, passed in via app.inviteUrl which showInvite() stashes before mounting.
import { html, OverlaySheet, t } from '../shared.js';

export function Invite({ app }: { app: AppState }) {
  const r: Room | null = app && app.room;
  if (!r) return html``;
  const url: string = app.inviteUrl || '';
  const origin = typeof location !== 'undefined' ? location.origin : '';
  // Nobody can ADD an AI any more — instead the sheet offers the one-liner a human pastes to their own
  // agent (Claude Code, Codex, anything with curl) so it joins THIS room over the agent API.
  const aiSection = r.phase === 'lobby' ? html`
      <div class="small muted" style="font-weight:900;margin:16px 0 6px">${t('invite.agentTitle')}</div>
      <div class="small muted" style="font-weight:700;margin-bottom:6px">${t('invite.agentSub')}</div>
      <div class="invite-link agent-prompt">${t('invite.agentPrompt', { origin, code: r.roomId })}</div>
      <button class="ghost sm" style="margin-top:8px" data-action="copy-agent-invite">${t('invite.agentCopy')}</button>` : html``;
  // No standard close-row footer here: the copy+close row sits mid-sheet (the AI roster follows
  // it), so the whole body — including that row — is passed as children, not the footer slot.
  return html`<${OverlaySheet}>
      <div class="big" style="font-size:22px">${t('invite.title')}</div>
      <div class="muted" style="font-weight:700;margin:6px 0 12px">${t('invite.sub')}</div>
      <div class="invite-code"><span class="small muted" style="font-weight:900">${t('invite.roomCode')}</span><span class="roomcode">${r.roomId}</span></div>
      <div class="invite-link">${url}</div>
      <div class="row" style="margin-top:14px"><button class="yellow" data-action="copy-invite">${t('invite.copy')}</button><button class="ghost" data-action="close-invite">${t('invite.close')}</button></div>
      ${aiSection}
    </${OverlaySheet}>
  `;
}
